import { render, staticRenderFns } from "./DietInformation.vue?vue&type=template&id=fa6129ee"
import script from "./DietInformation.vue?vue&type=script&lang=js"
export * from "./DietInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports